export default {

    props: {
        dataMode: {
            type: String,
            required: true,
        }
    },

    computed: {
        mode(){
            return this.dataMode
        },

        designMode() {
            return this.mode === 'DESIGN'
        },

        linkMode() {
            return this.mode === 'LINK'
        },
    },

}
